var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRancher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1172,
    viewBox: "0 0 256 120",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.868 26.32l-2.775-16.618C252.2 4.366 250.12 0 248.464 0c-1.656 0-3.01 4.425-3.01 9.834v4.344c0 5.41-4.433 9.834-9.854 9.834h-4.35c-.318 0-.63.013-.938.031v11.948c.308.015.62.027.937.027h16.383c5.42 0 9.127-4.363 8.236-9.698zM216.59 12.252h-26.567c-.222 0-.438.019-.654.034h-27.273c-.32 0-.632.03-.94.08V9.834c0-5.41-1.354-9.834-3.007-9.834-1.656 0-3.737 4.366-4.628 9.702l-2.775 16.618c-.891 5.332 2.815 9.698 8.233 9.698h16.385c1.687 0 3.281-.261 4.672-.723a6.011 6.011 0 0 1-5.908 4.899H151.15c-3.72 0-6.547-3.332-5.936-6.99l2.328-13.927c.61-3.662-2.217-6.99-5.933-6.99H27.26a6.013 6.013 0 0 0-5.477 3.525L.247 48.502c-.367.553-.32 1.28.108 1.787l4.178 4.923c.524.616 1.44.708 2.072.21l14.638-11.527v69.942c0 3.314 2.691 6.003 6.015 6.003h32.463c3.324 0 6.016-2.69 6.016-6.003V89.514c0-3.317 2.695-6.003 6.016-6.003h81.043c3.321 0 6.016 2.686 6.016 6.003v24.323c0 3.314 2.692 6.003 6.016 6.003h32.463c3.32 0 6.016-2.69 6.016-6.003V87.662h-17.243c-5.418 0-9.852-4.428-9.852-9.834V60.994c0-3.203 1.56-6.052 3.956-7.85v20.09c0 5.41 4.434 9.834 9.855 9.834h26.567c5.421 0 9.855-4.425 9.855-9.834V22.086c0-5.41-4.434-9.834-9.855-9.834z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRancher);
export default __webpack_public_path__ + "static/media/rancher.ac2f5b8bd3ab56f5b8fc693a9354c984.svg";
export { ForwardRef as ReactComponent };